// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"36e1a818","3780":"31b7c77d","4768":"0d5ebb8f"}[chunkId] + ".chunk.css";
};